import { API_ROUTES } from '../../utilities/routes';

const genericModelsRoutes = (server) => {
	server.get(`${API_ROUTES.MODELS}`, (schema) => schema.genericModels.all().models);
};

export default genericModelsRoutes;
